// @ts-nocheck
import appConfig from "@/config/app-config";

let _trackingEnabled = import.meta.env.PROD;
const mixpanelToken = appConfig.mixpanelToken;
let isInitialized = false;

export type TrackingEvent =
  | "LandedOnPage"
  | "OnboardingStarted"
  | "Screen"
  | "AnswerQuestion"
  | "OnboardingCompleted"
  | "OpenBankID";

const initMixPanel = () => {
  if (!window.mixpanel) {
    return;
  }

  if (mixpanelToken) {
    console.log("Initiating Mixpanel");
    window.mixpanel.init(mixpanelToken, {
      api_host: "https://api-eu.mixpanel.com",
      ip: false,
    });
    isInitialized = true;
  }
};

const Mixpanel = {
  init: () => {
    initMixPanel();
  },
  track: (name: TrackingEvent, props = {}) => {
    if (!window.mixpanel) {
      return;
    }

    if (!isInitialized) {
      initMixPanel();
    }

    if (!window.mixpanel.track) {
      console.log("Mixpanel.track not found");
      return;
    }

    const trackingProps = { ...props };
    if (_trackingEnabled && isInitialized) {
      try {
        window.mixpanel.track(name, trackingProps);
      } catch (e) {
        console.log(e);
      }
    } else if (!import.meta.env.PROD) {
      console.log("Tracking event", name, trackingProps);
    }
  },
  timeEvent: (name: TrackingEvent) => {
    if (!window.mixpanel) {
      return;
    }

    if (!isInitialized) {
      initMixPanel();
    }

    if (!window.mixpanel.time_event) {
      console.log("Mixpanel.time_event not found");
      return;
    }

    if (_trackingEnabled && isInitialized) {
      window.mixpanel.time_event(name);
    } else if (!import.meta.env.PROD) {
      console.log("Timing event", name);
    }
  },
  register: (superProperties) => {
    console.log("registering super property", superProperties);
    if (!window.mixpanel) {
      return;
    }

    if (!isInitialized) {
      initMixPanel();
    }

    try {
      window.mixpanel.register(superProperties);
    } catch (e) {
      console.log(e);
    }
  },
  reset: () => {
    if (_trackingEnabled && isInitialized) {
      window.mixpanel.reset();
    }
  },
};

export default Mixpanel;
